import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Card, Col, Row, Spin, Result, Button, Typography } from 'antd'
import { useParams, useHistory, useLocation } from 'react-router-dom'
import instance from '../../utils/API'
import NotFound from '../NotFound'
import Animate from 'rc-animate';
import TimeAgo from 'react-timeago'
import Vimeo from '@u-wave/react-vimeo'
import ReactPlayer from 'react-player'
import SignInForm from '../../components/SignInForm'


const { Text } = Typography;

const ArticlePage = () => {
    let { slug } = useParams();
    const history = useHistory()
    const location = useLocation()


    const user = useSelector(state => state.user)

    const [article, setArticle] = useState({});
    const [loading, setLoading] = useState();
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState();

    const getVideo = (url) =>{ 

        if (url.includes("vimeo")){
            return (
                <Vimeo
                    video={url}
                    responsive
                    color={"14e3ba"}
                    controls={true}
                    showTitle={false}
                />
            )
        }else{
            return (
                    <div className="player-wrapper">
                        <ReactPlayer
                            className='react-player'
                            url={url}
                            width="100%"
                            height="100%"
                            controls={true}
                        />
                    </div>
            )
        }
    }

    useEffect(() => {
        if(!loading && !article)
        setLoading(true)

        instance(user.jwt).get("/articles/"+ slug)
            .then(function (response) {
                setArticle(response.data)
                setErrorMessage("");
                setError(false);
                setLoading(false);
            })
            .catch(function (error) {
                setErrorMessage(error.response.data);
                setError(true);
                setLoading(false);
            })
    }, [user]);

    if(loading) return (
        <Row justify="center">
                <Col>
                    <Spin
                        size="large"
                        spinning={loading}
                        delay={100}
                    ></Spin>
                </Col>
        </Row>
    )
    
    if(error) {    
        if(errorMessage.statusCode == "403"){
            return (
                <Animate
                            transitionName="fade"
                            transitionAppear
                        >
                <Result
                    status="warning"
                    title="This content available only for Odin Subscribed Members"
                    extra={
                    <Button type="primary" key="goPro"
                        onClick={()=>{history.push("/services")}}
                        >
                        Become Odin Member
                    </Button>
                    }
                />
                </Animate>
            )
        }else if (errorMessage.statusCode == "401") {
            return (
                <Animate
                            transitionName="fade"
                            transitionAppear
                        >
                        <Row justify="center" style={{marginTop:50}}>
                            <Col xs={20} sm={16} md={8} lg={6} xl={4} >
                                <SignInForm redUrl={location.pathname}/>
                            </Col>
                        </Row>
                </Animate>
            )
        }
        else{
            return <NotFound/>
        }
    }

    return (
        <Spin
            size="large"
            spinning={loading}
            delay={100}
        >
        <Animate
                    transitionName="fade"
                    transitionAppear
                >
                <Row justify="center">
                    <Col xs={24} sm={18} md={18} lg={14} xl={14} >
                        <Card
                            bordered={false}
                            title={
                                <>
                                <Row>
                                    {article.title}
                                </Row>
                                <Row justify="end">
                                    <Text type="secondary" style={{fontSize:10}}>
                                        Published: <TimeAgo date={article.publishAt}/>
                                    </Text>
                                </Row>
                                </>
                            }
                            style={{
                                borderRadius: 10, 
                                marginBottom: 25,
                                boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.6)" 
                            }}
                        >
                            { article.videoUrl &&
                                    getVideo(article.videoUrl)
                            }

                            <div
                            dangerouslySetInnerHTML={{
                            __html: article.content
                            }}>
                            </div>
                        </Card>

                    </Col>
                </Row>
        </Animate>
        </Spin>
    )
}

export default ArticlePage
